import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getRevisionTenantGroupOverrides } from 'Services';
import { RQ_RULE_REVISION_TENANT_GROUP_OVERRIDES } from 'Utils';

const useGetTenantGroupOverrideRules = (enabled?: boolean) => {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery(
        [RQ_RULE_REVISION_TENANT_GROUP_OVERRIDES],
        () => getRevisionTenantGroupOverrides(templateRepositoryId!),
        {
            enabled: !!(templateRepositoryId && templateRepositoryId > 0) && enabled !== false
        }
    );
};

export default useGetTenantGroupOverrideRules;
